/**
 * Helpers for saving parsed workout-import results into coach programs (template weeks).
 */

export function workoutToTemplateInfo(workout = {}) {
  return {
    name: workout.name || "Untitled Workout",
    description: workout.description || "",
    exercises: workout.exercises || [],
  };
}

/**
 * @param {Array<{ week: number, workouts: Array<{ workout: object }> }>} importWeeks
 * @param {(body: { coachId: string, workoutInfo: object }) => Promise<{ template?: { id: string } }>} createWorkoutTemplate
 * @param {string} coachId
 * @returns {Promise<string[][]>} template IDs grouped by week
 */
export async function buildTemplateWeeksFromImport(
  importWeeks,
  createWorkoutTemplate,
  coachId
) {
  const sortedWeeks = [...importWeeks].sort((a, b) => a.week - b.week);
  const templateWeeks = [];

  for (const weekData of sortedWeeks) {
    const weekTemplateIds = [];
    for (const item of weekData.workouts || []) {
      const response = await createWorkoutTemplate({
        coachId,
        workoutInfo: workoutToTemplateInfo(item.workout),
      });
      const templateId = response?.template?.id;
      if (templateId) {
        weekTemplateIds.push(templateId);
      }
    }
    templateWeeks.push(weekTemplateIds);
  }

  return templateWeeks;
}

/**
 * @param {string[][]} existingWeeks
 * @param {string[][]} importedWeeks
 * @param {'replace' | 'append'} mergeMode
 */
export function mergeProgramWeeks(existingWeeks, importedWeeks, mergeMode) {
  const normalizedExisting = (existingWeeks || []).map((w) =>
    Array.isArray(w) ? [...w] : []
  );
  const normalizedImported = (importedWeeks || []).map((w) =>
    Array.isArray(w) ? [...w] : []
  );

  if (mergeMode === "append") {
    return [...normalizedExisting, ...normalizedImported];
  }
  return normalizedImported;
}

export function defaultImportedProgramName(importWeeks) {
  const firstWorkout = importWeeks?.[0]?.workouts?.[0]?.workout;
  if (firstWorkout?.name) {
    return `${firstWorkout.name} Program`;
  }
  return "Imported Program";
}
